/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Status } from 'components';
import { useMixpanel } from 'context';
import { OnrampLayout } from 'onramp-pages/components';
import { useOrderStatusPolling } from 'onramp-pages/hooks/useOrderStatusPolling';

export const Processing = () => {
  const { formatMessage } = useIntl();
  const { spacing } = useTheme();
  const navigate = useNavigate();
  const { mixpanelTrackEvent } = useMixpanel({
    Product: 'TopUp',
    Page: 'Processing',
  });
  useOrderStatusPolling({
    onStatusChange: (data) => {
      const { status } = data;
      if (['COMPLETE', 'CRYPTO_RECEIVED', 'CRYPTO_SOLD'].includes(status)) {
        mixpanelTrackEvent('Processing completed', {
          description: 'User completed the send order processing step.',
        });
        navigate('/onramp/success');
      }
      if (status === 'CANCELLED') {
        navigate('/onramp/cancelled');
      }
    },
  });

  return (
    <OnrampLayout
      topChildren={
        <Status
          heading={formatMessage({
            id: 'page.send.processing.heading',
          })}
          subHeading={formatMessage({
            id: 'page.send.processing.subheading',
          })}
          imageProps={{
            name: 'transferLoading',
            size: spacing.xxl,
            showPlaceholder: false,
          }}
        />
      }
    />
  );
};

export default Processing;
